import FieldDefs from './OutlinksDomainsFieldDefs'
import {doLangFields} from '../../lib/ks-tools'
import {Listeners} from "../../constants/listeners";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.outlinks-domains.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'backlinks_count',
                    direction: 'desc'
                }
            ],
            moreParams: {},
            additionalActions: [],
            viewMode: "all",
            options: [
                {label: this.$t('lang.report.outlinks-domains.data_all'), value: 'all'},
                {label: this.$t('lang.report.outlinks-domains.data_domain'), value: 'domain'},
            ],
        }
    },
    props: {
        domain: {
            type: String,
            required: true
        }
    },
    methods: {
        initFields() {
            let self = this;
            self.fields.forEach((f) => {
                if (f.hasOwnProperty('visibleRule')) {
                    f.visible = eval(f.visibleRule);
                }
            });
            self.$emitter.emit(Listeners.KS_TABLE_NORMALIZE_FIELDS);
            self.$emitter.emit(Listeners.KS_FILTER_SIMPLE_CLEAR);
        }
    },
    computed: {
        getApiUrl(){
            return '/report/simple/links/outlinks-domains?domain=' + this.domain + '&view=' + this.viewMode;
        },
        self() {
            return this;
        },
    },
    watch: {
        viewMode: function(){
            this.initFields();
        }
    }
}
